import {useAppState} from 'store/utils';
import {
  EventRegistrator,
  SimpleRegistrator,
  RuntimeArguments,
  payloadBuilderFor,
  sendEvent,
} from 'ui/adapters/Analytics';

export function useAnalytics<TRegistrator extends EventRegistrator = SimpleRegistrator>(
  event: AnalyticsEventName
): TRegistrator {
  const payloadFrom = payloadBuilderFor(event);
  const appState = useAppState();

  function registerEvent(): void;
  function registerEvent(index: number): void;
  function registerEvent(...args: RuntimeArguments): void {
    const data = payloadFrom && payloadFrom(appState, ...args);
    return sendEvent({event, data});
  }

  return registerEvent as TRegistrator;
}
